import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDriverLicenseHome = loadable(
  () => import('./PrequalDriverLicenseHome'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableDriverLicenseHome;
